module.exports = __webpack_public_path__ + "img/step5-06.dd073cb5.jpg";